export default __webpack_public_path__ + "static/media/fr-asia-11.3bf9015f.jpg";